module.exports = __webpack_public_path__ + "img/pencil.9b53eff9.svg";